var React = require('react');
var { connect } = require('react-redux');
var authenticateActions = require('authenticateActions');
var countryDialPrefixManager = require('countryDialPrefixManager');
var { sortArrayByValue, upper } = require('helpers');
var { withTranslation } = require('react-i18next');
var $ = require('jquery');

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      login_form_additional_classes: '',
      user_name: this.props.user_name,
      shouldDisplayPassword: false,
      shouldDisplayConfirmPassword: false,
    };

    // Create refs for form inputs
    this.first_name = React.createRef();
    this.last_name = React.createRef();
    this.email = React.createRef();
    this.password = React.createRef();
    this.confirm_password = React.createRef();
    this.dial_prefix_field = React.createRef();
    this.phone_number = React.createRef();

    this.onRegisterButtonClick = this.onRegisterButtonClick.bind(this);
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.onTermsClick = this.onTermsClick.bind(this);
    this.handleVisiblePassword = this.handleVisiblePassword.bind(this);
    this.handleVisibleConfirmPassword =
      this.handleVisibleConfirmPassword.bind(this);
    this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
  }

  componentDidMount() {
    this.setState({
      dial_prefixes: countryDialPrefixManager.get_dial_code_prefixes(),
    });
  }

  onTermsClick(e) {
    $('#termsAndConditionsId').modal('show');
  }

  onRegisterButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var form = document.getElementById('login-form');

    this.validateConfirmPassword();

    // Local check (given by bootstrap)
    if (form.checkValidity() == true) {
      let currentDialPrefixObject =
        this.state.dial_prefixes[
          parseInt(this.dial_prefix_field.current.value)
        ];

      var phone_number = countryDialPrefixManager.generate_phone_number(
        currentDialPrefixObject.prefix,
        this.phone_number.current.value,
      );
      let userCountry = currentDialPrefixObject.country;

      // return to main login handler
      this.props.dispatch(
        authenticateActions.register(
          this.state.user_name.toLowerCase(),
          upper(this.first_name.current.value),
          upper(this.last_name.current.value),
          phone_number,
          this.password.current.value,
          userCountry,
        ),
      );
    }

    // refresh login form according to local check
    this.setState({ login_form_additional_classes: 'was-validated' });
  }

  handleUserNameChange(event) {
    this.setState({ user_name: event.target.value });
  }

  handleVisiblePassword() {
    this.setState((prevState) => ({
      shouldDisplayPassword: !prevState.shouldDisplayPassword,
    }));
  }

  handleVisibleConfirmPassword() {
    this.setState((prevState) => ({
      shouldDisplayConfirmPassword: !prevState.shouldDisplayConfirmPassword,
    }));
  }

  // A mismatch marks the confirm input :invalid, so it fails form.checkValidity()
  // and shows its invalid-feedback like any other field
  validateConfirmPassword() {
    var confirmPassword = this.confirm_password.current;
    confirmPassword.setCustomValidity(
      confirmPassword.value === this.password.current.value
        ? ''
        : this.props.t('login_passwords_must_match'),
    );
  }

  render() {
    const { t } = this.props;

    var { register_fail_error } = this.props.authentication_data.register_flow;
    var login_form_additional_classes =
      this.state.login_form_additional_classes;

    return (
      <form
        className={`needs-validation ${this.state.login_form_additional_classes}`}
        noValidate
        onSubmit={this.onRegisterButtonClick}
        id='login-form'
      >
        <div className='form-row'>
          <div className='col'>
            <div className='form-group ml-2 mr-2 mt-3 text-grey45'>
              <label htmlFor='first_name'>{t('first_name')}</label>
              <input
                type='text'
                ref={this.first_name}
                className='form-control'
                placeholder={t('login_enter_first_name')}
                required
              />
              <div className='invalid-feedback'>
                {t('account_first_name_invalid_data_message')}
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='form-group ml-2 mr-2 mt-3 text-grey45'>
              <label htmlFor='last_name'>{t('last_name')}</label>
              <input
                type='text'
                ref={this.last_name}
                className='form-control '
                placeholder={t('login_enter_last_name')}
                required
              />
              <div className='invalid-feedback'>
                {t('account_last_name_invalid_data_message')}
              </div>
            </div>
          </div>
        </div>

        <div className='form-group ml-2 mr-2 mt-1 text-grey45'>
          <label htmlFor='emailInput'>{t('email')}</label>
          <input
            type='email'
            ref={this.email}
            className='form-control '
            value={this.state.user_name}
            onChange={this.handleUserNameChange}
            placeholder={t('login_enter_your_email')}
            required
          />
          <div className='invalid-feedback'>
            {t('login_enter_a_valid_email')}
          </div>
        </div>

        <div className='form-group ml-2 mr-2 mt-1 text-grey45'>
          <label htmlFor='passwordInput'>{t('password')}</label>
          <div style={{ position: 'relative' }}>
            <input
              type={this.state.shouldDisplayPassword ? 'text' : 'password'}
              ref={this.password}
              className='form-control'
              placeholder={t('login_enter_your_password')}
              autoComplete='new-password'
              onChange={this.validateConfirmPassword}
              required
            />
            <div onClick={this.handleVisiblePassword}>
              <img
                style={{ position: 'absolute', right: '12px', top: '12px' }}
                src={
                  this.state.shouldDisplayPassword
                    ? require('images/login/eye - open.svg')
                    : require('images/login/eye - closed.svg')
                }
              />
            </div>
            <small className='form-text text-muted'>
              {t('login_password_limitation_message')}
            </small>
            <div className='invalid-feedback'>
              {t('login_enter_your_password')}
            </div>
          </div>
        </div>

        <div className='form-group ml-2 mr-2 mt-1 text-grey45'>
          <label htmlFor='confirmPasswordInput'>
            {t('login_confirm_password')}
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type={
                this.state.shouldDisplayConfirmPassword ? 'text' : 'password'
              }
              ref={this.confirm_password}
              className='form-control'
              id='confirmPasswordInput'
              placeholder={t('login_reenter_your_password')}
              autoComplete='new-password'
              onChange={this.validateConfirmPassword}
              required
            />
            <div onClick={this.handleVisibleConfirmPassword}>
              <img
                style={{ position: 'absolute', right: '12px', top: '12px' }}
                src={
                  this.state.shouldDisplayConfirmPassword
                    ? require('images/login/eye - open.svg')
                    : require('images/login/eye - closed.svg')
                }
              />
            </div>
            <div className='invalid-feedback'>
              {t('login_passwords_must_match')}
            </div>
          </div>
        </div>

        <div className='form-row'>
          <div className='col-4 '>
            <div className='form-group ml-2 mr-2 mt-1 text-grey45'>
              <label htmlFor='dial_prefix'>{t('prefix')}</label>
              <select
                className='form-control'
                ref={this.dial_prefix_field}
                id='exampleFormControlSelect1'
              >
                {this.state.dial_prefixes &&
                  sortArrayByValue(this.state.dial_prefixes, 'name').map(
                    (item, index) => {
                      return (
                        <option key={index} value={index}>
                          {item['name']}
                        </option>
                      );
                    },
                  )}
              </select>
            </div>
          </div>
          <div className='col-8'>
            <div className='form-group ml-2 mr-2 mt-1 text-grey45'>
              <label htmlFor='phone_number'>{t('phone_number')}</label>
              <input
                type='text'
                ref={this.phone_number}
                className='form-control '
                placeholder={t('login_enter_phone_number')}
                required
              />
              <div className='invalid-feedback'>
                {t('account_phone_number_invalid_data_message')}
              </div>
            </div>
          </div>
        </div>

        <div className='form-check  ml-2 mr-2 mt-2'>
          <input
            className='form-check-input'
            type='checkbox'
            value=''
            id='termsAgreement'
            required
          />
          <label className='text-grey' htmlFor='termsAgreement'>
            {t('i_agree_to')}
            <u>
              {' '}
              <a
                href='#'
                onClick={(e) => {
                  this.onTermsClick(e);
                }}
              >
                {t('terms_and_conditions')}
              </a>
            </u>
          </label>
          <div className='invalid-feedback mt-0 pt-0'>
            You must agree before registering.
          </div>
        </div>

        <div className='text-center text-red'>{register_fail_error}</div>

        <div className='text-center'>
          <button
            type='submit'
            style={{ opacity: '0.9' }}
            className='btn btn-grey45 btn-lg general-button mt-3'
            disabled={
              this.props.authentication_data.register_flow.during_register
            }
          >
            {t('register')}
            {this.props.authentication_data.register_flow.during_register && (
              <span>
                &nbsp;&nbsp;
                <span
                  className='spinner-grow spinner-grow-sm mb-1'
                  role='status'
                  aria-hidden='true'
                ></span>
              </span>
            )}
          </button>
        </div>

        <div className='text-center mt-4 mb-5'>
          <br />
          <br />
          <br />
        </div>
      </form>
    );
  }
}

module.exports = connect((state) => {
  return {
    authentication_data: state.authentication_data,
  };
})(withTranslation()(RegisterForm));
